import React, { useState, useEffect, Fragment } from 'react';
// import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { ResponseSuccessModal, ResponseFailModal } from '../../modal/Response';
import Spin from '../../Spin';
import * as api from '../../../api';

const ExcelUpload = ({
  isOpen,
  toggle,
  reload,
}) => {
  const { t } = useTranslation();
  const [ isLoading, setIsLoading ] = useState(false);
  const [ isOpenExcelUploadSuccessModal, setIsOpenExcelUploadSuccessModal ] = useState(false);
  const [ isOpenExcelUploadFailModal, setIsOpenExcelUploadFailModal ] = useState(false);
  const [ messageExcelUploadFail, setMessageExcelUploadFail ] = useState('');
  const [ selectedFileName, setSelectedFileName ] = useState('');
  // const [ isMobilekey, setIsMobilekey ] = useState(false);
  // const [ isPincode, setIsPincode ] = useState(false);
  // const [ pincodeType, setPincodeType ] = useState('day');
  // const { pincodeVersion } = useSelector(state => state.sidebar);
  const [ formData, setFormData ] = useState(null);

  const createBooking = async () => {
    try {
      if (!formData || !formData.get('file')) {
        setMessageExcelUploadFail(t('error_message.no_file'));
        setIsOpenExcelUploadFailModal(true);
      } else {
        // formData.set('is_mobilekey', isMobilekey);
        // formData.set('is_pincode', isPincode);
        // formData.set('pincode_version', pincodeVersion);
        // formData.set('pincode_type', pincodeType);
        setIsLoading(true);
        await api.createBookingByExcelUpload(formData);
        reload();
        toggle();
        setIsOpenExcelUploadSuccessModal(true);
      }
    } catch (error) {
      if (!error.response) setMessageExcelUploadFail(error.message);
      else setMessageExcelUploadFail(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenExcelUploadFailModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  const setFile = (file) => {
    if (file) {
      setSelectedFileName(file.name);
      formData.set('file', file);
    }
  }

  useEffect(() => {
    if(isOpen){
      setFormData(new FormData());
    }else{
      setSelectedFileName('');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <Fragment>
      <Modal
        show={isOpen}
        onHide={() => toggle()}
        centered
        backdrop='static'
        size='sm'
      >
        <Spin isSpin={isLoading} isModal={true}/>
        <ModalBody className='text-center m-3' style={{margin:0, padding:0, backgroundColor:'#282C34'}}>
          <div className='form-card'>
            <div className='form-card-title'>
              <h4>{t('content_title.booking_upload')}</h4>
            </div>
            <div className='inline-flex'>
              <div className='file-upload-body'>
                {/* <div className='file-upload-key-type-wrap'>
                  <p className='file-upload-key-type-header'>키 선택</p>
                  <div className='file-upload-key-type-checkbox-wrap'>
                    <label htmlFor='mobilekey'>
                      <input type='checkbox' id='mobilekey' onChange={(e) => setIsMobilekey(e.target.checked)}/>
                      <span className='cbx'>
                        <svg width='12px' height='11px' viewBox='0 0 12 11'>
                          <polyline points='1 6.29411765 4.5 10 11 1'></polyline>
                        </svg>
                      </span>
                      <span>모바일키</span>
                    </label>
                  </div>
                  <div className='file-upload-key-type-checkbox-wrap'>
                    <label htmlFor='pincode'>
                      <input type='checkbox' id='pincode' onChange={(e) => setIsPincode(e.target.checked)}/>
                      <span className='cbx'>
                        <svg width='12px' height='11px' viewBox='0 0 12 11'>
                          <polyline points='1 6.29411765 4.5 10 11 1'></polyline>
                        </svg>
                      </span>
                      <span>핀코드</span>
                    </label>
                  </div>
                  <div className='file-upload-pincode-type-radio-wrap' hidden={pincodeVersion !== 'V2' || !isPincode}>
                    <label htmlFor='day'>
                      <input type='radio' id='day' name='pincode-type' value='day' checked={pincodeType === 'day'} onChange={(e) => setPincodeType(e.target.value)}/>
                      <span className='rdo'></span>
                      <span>일단위</span>
                    </label>
                    <label htmlFor='hour'>
                      <input type='radio' id='hour' name='pincode-type' value='hour' checked={pincodeType === 'hour'} onChange={(e) => setPincodeType(e.target.value)}/>
                      <span className='rdo'></span>
                      <span>시간단위</span>
                    </label>
                    <label htmlFor='10mins'>
                      <input type='radio' id='10mins' name='pincode-type' value='10mins' checked={pincodeType === '10mins'} onChange={(e) => setPincodeType(e.target.value)}/>
                      <span className='rdo'></span>
                      <span>10분단위</span>
                    </label>
                  </div>
                </div> */}
                <div className='file-wrap'>
                  <div className='file-upload-file-header'>
                    <p className='file-upload-file-header-label'>{t('data_column.file_select')}<span className='required'> *</span></p>
                    {/* <div className='excel-download-wrap'>
                      <img className='excel-logo' src='../assets/images/excel.png' alt='excel_logo'></img>
                      <span>엑셀 파일 양식 다운로드</span>
                    </div> */}
                  </div>
                  <div className='file-upload-select-wrap'>
                    <label htmlFor='file-label'>{selectedFileName || t('placeholder.file_select')}</label>
                    <input type='file' id='file-label' className='upload-hidden' onChange={e => setFile(e.target.files[0])}/>
                  </div>
                </div>
              </div>
            </div>
            {/* <input className='modal-form-input' type='file' onChange={e => setFile(e.target.files[0])}></input> */}
            <div className='card-foot'>
              <div className='form-item-cancel'>
                <button className='btn-item-cancel' onClick={() => toggle()}>
                  <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/><span>{t('button.cancel')}</span>
                </button>
              </div>
              <div className='form-item-add center'>
                <button className='btn-item-add' onClick={() => createBooking()}>
                  <FontAwesomeIcon icon={faSave} style={{paddingRight:'2px'}}/><span>{t('button.ok')}</span>
                </button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <ResponseSuccessModal
        isOpen={isOpenExcelUploadSuccessModal}
        toggle={() => setIsOpenExcelUploadSuccessModal(!isOpenExcelUploadSuccessModal)}
        message={t('success_message.upload_file')}
      />
      <ResponseFailModal
        isOpen={isOpenExcelUploadFailModal}
        toggle={() => setIsOpenExcelUploadFailModal(!isOpenExcelUploadFailModal)}
        message={messageExcelUploadFail || t('error_message.upload_file')}
      />
    </Fragment>
  );
}

export default ExcelUpload;